module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/346.48e8828f.png";